import { SetStateAction, useEffect, useState } from "react";
import {
    Alert,
    AlertColor,
    Box,
    Button,
    Divider,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
    AlertPropsVariantOverrides
} from "@mui/material";
import { OverridableStringUnion } from '@mui/types';
import styled from "@emotion/styled";
import AdminNationalHolidayPicker from "../../elements/AdminNationalHolidayPicker";
import axiosInstance from "../../../services/axios-instance";
import axios from 'axios';
import {
    All_USERS_DAYS_OFF,
    NATIONAL_HOLIDAYS_URL,
    DAYS_AVAILABLE
} from "../../../services/endpoints";

const AdminSelect = styled(Box)`
    border: 1px solid #c0c0c0;
    width: 420px;
    border-radius: 4px;
    box-shadow: 0px 0px 9px 0px rgba(112, 112, 112, 0.5);
    -webkit-box-shadow: 0px 0px 9px 0px rgba(112, 112, 112, 0.5);
    -moz-box-shadow: 0px 0px 9px 0px rgba(112, 112, 112, 0.5);
    margin: 12px 0px;
`;

const SelectDaysForm = styled(Box)`
    margin: 8px;
    width: 44ch;
    height: 3.4rem;
    border-radius: 4px;
    border: 1px solid #c0c0c0;
`;

const AdminNationalHolidaysSetter = () => {
    // pop-up message
    const [title, setTitle] = useState("National Holidays");
    const [dates, setDates] = useState<string[]>([]);
    const [reset, setReset] = useState(false);

    const [alertMessage, setAlertMessage] = useState("");
    const [severity, setSeverity] = useState<AlertColor | undefined>("info");
    const [variant, setVariant] = useState<OverridableStringUnion<"standard" | "filled" | "outlined", AlertPropsVariantOverrides> | undefined>("filled");

    const [daysOffMessage, setDaysOffMessage] = useState("");
    const [daysOffSeverity, setDaysOffSeverity] = useState<AlertColor | undefined>("info");

    const dataToSave = {
        title: title,
        dates: dates,
    };

    useEffect(() => {
        if (reset) {
            setTitle("");
        }
    }, [reset]);

    useEffect(() => {
        setAlertMessage("");
        setSeverity("info");
        setVariant("filled")
    }, [dataToSave.title, dataToSave.dates]);

    const handleNatinalHolidays = async () => {
        if (title.trim() === "") {
            setAlertMessage("Please provide a title for the national holidays.");
            setSeverity("error")
            return;
        }

        if (dates.length === 0) {
            setAlertMessage(
                "Please select at least one date for the national holidays."
            );
            setSeverity("error")
            return;
        }

        try {
            const resNatHolidays = await axiosInstance.post(
                NATIONAL_HOLIDAYS_URL,
                dataToSave
            );
            if (resNatHolidays.status === 200) {
                setAlertMessage("National Holidays created successfully!");
                setSeverity('success');
            }
        } catch (error) {
            setAlertMessage(
                "Invalid date or the date specified is already recognized as a national holiday."
            );
            setSeverity("error")
            console.error("An error occurred:", error);
        }
    };

    const currentYear = new Date().getFullYear();
    const prevYear = currentYear - 1;
    const nextYear = currentYear + 1;
    const yearsArray = [prevYear, currentYear, nextYear];

    // add total holidays for prev and current year
    const [users, setUsers] = useState<any[]>([]);

    const [selectedUser, setSelectedUser] = useState("");

    const [selecteYear, setSelectedYear] = useState("");

    const [availableDaysOff, setAvailableDaysOff] = useState<
        number | null
    >(null);

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                const response = await axiosInstance.get(All_USERS_DAYS_OFF);
                setUsers(response.data.data);
            } catch (error) {
                console.error(error);
            }
        };

        fetchUsers();
    }, []);

    useEffect(() => {
        setAvailableDaysOff(null);
        if (selecteYear && selectedUser) {
            if(selectedUser != 'all')
            {
                const foundObject = users.find(obj => obj['id'] === +selectedUser);
                if (foundObject['days_off'] && foundObject['days_off'][selecteYear]) {
                    setAvailableDaysOff(foundObject['days_off'][selecteYear])
                }
            }
        }
    }, [selecteYear, selectedUser]);

    const handleSubmit = async (event: { preventDefault: () => void }) => {
        event.preventDefault();
        setDaysOffSeverity('error');
        if (
            availableDaysOff != null && selecteYear
        ) {
            try {
                const response = await axiosInstance.post(
                    DAYS_AVAILABLE,
                    {
                        total: availableDaysOff,
                        year: selecteYear,
                        user: selectedUser
                    }
                );
                if (response) {
                    setAvailableDaysOff(null);
                    setSelectedYear("");
                    setSelectedUser("");
                    setDaysOffSeverity('success');
                    setDaysOffMessage("Available days updated.")
                }
            } catch (error) {
                if(axios.isAxiosError(error)) {
                    console.error(error.response?.data.message);
                    setDaysOffMessage(error.response?.data.message);
                }
            }
        } else {
            setDaysOffMessage("Fields can't be empty");
        }
    };

    const handleSelectUser = (event: { target: { value: SetStateAction<string>; }; }) => {
        setSelectedUser(event.target.value);
      };

    const handleAvailableDaysOffChange = (
        e: React.ChangeEvent<HTMLInputElement>
    ) => {
        const input = e.target.value;
        // Only allow numeric input
        if (/^\d*$/.test(input)) {
            setAvailableDaysOff(Number(input));
        }
    };

    return (
        <>
            <AdminSelect>
                <Box sx={{ pt: 3, p: 1 }}>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <Divider textAlign="center" sx={{ mb: 2.5, pt: 2 }}>
                            <span style={{ fontWeight: 600 }}>
                                Select the National Holidays
                            </span>
                        </Divider>
                        <Box sx={{ display: "flex" }}>
                            <Box>
                                <Box>
                                    <SelectDaysForm
                                        sx={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                        }}
                                    >
                                        <p
                                            style={{
                                                paddingLeft: "12px",
                                                paddingRight: "12px",
                                            }}
                                        >
                                            Select all the dates
                                        </p>

                                        <AdminNationalHolidayPicker
                                            setDates={setDates}
                                            setReset={setReset}
                                            reset={reset}
                                        />
                                    </SelectDaysForm>
                                </Box>
                                <Box
                                    component="form"
                                    sx={{
                                        "& > :not(style)": {
                                            m: 1,
                                            width: "44ch",
                                        },
                                    }}
                                    noValidate
                                    autoComplete="off"
                                >
                                    <TextField
                                        id="outlined-basic"
                                        label="Holidays Title*"
                                        variant="outlined"
                                        value={title}
                                        onChange={(e) =>
                                            setTitle(e.target.value)
                                        }
                                    />
                                </Box>
                                <Box
                                    sx={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                    }}
                                >
                                    <Button
                                        variant="contained"
                                        color="info"
                                        sx={{
                                            textTransform: "none",
                                            fontWeight: "600",
                                            m: 1,
                                        }}
                                        onClick={handleNatinalHolidays}
                                    >
                                        Save
                                    </Button>
                                    <Button
                                        variant="outlined"
                                        color="error"
                                        sx={{
                                            textTransform: "none",
                                            fontWeight: "600",
                                            m: 1,
                                        }}
                                        onClick={() => setReset(true)}
                                    >
                                        Reset
                                    </Button>
                                </Box>
                                {alertMessage != "" &&
                                (<Alert onClick={()=>setAlertMessage("")} variant={variant} severity={severity}>{alertMessage}</Alert>)}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </AdminSelect>

            <AdminSelect>
                <Box sx={{ pt: 3, p: 1 }}>
                    <Box
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                        <Divider textAlign="center" sx={{ mb: 2.5, pt: 2 }}>
                            <span style={{ fontWeight: 600 }}>
                                Please enter the total days off
                                <br />
                                available per year
                            </span>
                        </Divider>
                        <Box sx={{ display: "flex" }}>
                            <Box>
                                <Box>
                                    <form
                                        onSubmit={handleSubmit}
                                        style={{
                                            margin: "auto",
                                            marginBottom: "12px",
                                            width: "fit-content"
                                        }}
                                    >
                                        <FormControl
                                            style={{
                                                marginBottom: "12px",
                                            }}
                                        >
                                            <FormControl>
                                            <InputLabel id="year-select-label">
                                                Select Year
                                            </InputLabel>
                                            <Select
                                                labelId="year-select-label"
                                                label="Select Yaer"
                                                id="year-select"
                                                value={selecteYear}
                                                onChange={(e) => {
                                                    setSelectedYear(e.target.value);
                                                }}
                                                style={{
                                                    marginBottom: "12px",
                                                }}
                                            >
                                                {yearsArray.map((year) => (
                                                    <MenuItem
                                                        key={year}
                                                        value={year}
                                                    >
                                                        {year}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                        <FormControl>
                                            <InputLabel id="user-select-label">
                                                Select User
                                            </InputLabel>
                                            <Select
                                                labelId="user-select-label"
                                                label="Select User"
                                                id="user-select"
                                                onChange={handleSelectUser}
                                                style={{
                                                    marginBottom: "12px",
                                                }}
                                                value = {selectedUser}
                                            >
                                                <MenuItem
                                                    key={"all"}
                                                    value={"all"}
                                                >
                                                    {"All"}
                                                </MenuItem>
                                                {users.map((user) => (
                                                    <MenuItem
                                                        key={user.id}
                                                        value={user.id}
                                                    >
                                                        {user.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                            <TextField
                                                id="outlined-controlled"
                                                name="currentYearAvailableDaysOff"
                                                label="Available days off"
                                                autoComplete="off"
                                                InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                value={
                                                    availableDaysOff
                                                }
                                                onClick={() =>
                                                    setAvailableDaysOff(null)
                                                }
                                                onChange={
                                                    handleAvailableDaysOffChange
                                                }
                                                style={{
                                                    marginBottom: "12px",
                                                }}
                                            />
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                color="info"
                                                style={{
                                                    marginBottom: "12px",
                                                }}
                                            >
                                                Submit
                                            </Button>
                                        </FormControl>
                                        </FormControl>
                                    </form>
                                    {daysOffMessage != "" &&
                                            (<Alert onClick={()=>setAlertMessage("")} variant={variant} severity={daysOffSeverity}>{daysOffMessage}</Alert>)}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </AdminSelect>
        </>
    );
};

export default AdminNationalHolidaysSetter;
